import {Component, EventEmitter, Input, Output} from "@angular/core";
import {IClinicalResponse} from "../../../../../app.services/clinical/interfaces/clinical.response";

@Component({
	selector: 'cp-expandable-error-popup',
	templateUrl: './expandable.error.template.html',
	styleUrls: ['./expandable.error.style.scss']
})
export class ExpandableErrorComponent {
	@Input() response: IClinicalResponse;
	@Input() showException: boolean;
	@Output() close = new EventEmitter();

	onClose() {
		this.close.emit(null);
	}
}
